export default __webpack_public_path__ + "static/media/linx-logo.e54db2d2.svg";